import { IGetEstacionalRequest } from 'src/app/core/interfaces/estacional-prediction.interface';

export class UpdateModifiedDataSeasonal {
  static readonly type = '[SeasonalPrediction] Update Modified Data Seasonal';
  constructor(public payload: { key: string; value: number }) {}
}

export class SetRowDataSeasonal {
  static readonly type = '[SeasonalPrediction] Set Row Data';
  constructor(public payload: any[]) {}
}

export class GetAllListSeasonal {
  static readonly type = '[SeasonalPrediction] Get All List Seasonal';
  constructor() {}
}

export class SetActualBaseSeasonal {
  static readonly type = '[SeasonalPrediction] Set Actual Base Seasonal';
  constructor(public payload: number) {}
}

export class SetActualFiltersSeasonal {
  static readonly type = '[SeasonalPrediction] Set ActualFilters';
  constructor(public payload: any[]) {}
}
export class SetEndDateSeasonal {
  static readonly type = '[SeasonalPrediction] Set EndDate Seasonal';
  constructor(public payload: string) {}
}
export class SetInitialDateSeasonal {
  static readonly type = '[SeasonalPrediction] Set StartDate Seasonal';
  constructor(public payload: string) {}
}

export class SetIgnoredDatesSeasonal {
  static readonly type = '[SeasonalPrediction] Set IgnoredDatesSeasonal';
  constructor(public payload: any[]) {}
}

export class SetExcludePUDCItemsSeasonal {
  static readonly type = '[SeasonalPrediction] Set ExcludePUDCItems Seasonal';
  constructor(public payload: any[]) {}
}

export class SetExcludeRCTDACItemsSeasonal {
  static readonly type = '[SeasonalPrediction] Set ExcludeRCTDACItems Seasonal';
  constructor(public payload: any[]) {}
}

export class SetExcludeRCUDCItemsSeasonal {
  static readonly type = '[SeasonalPrediction] Set ExcludeRCUDCItemsSeasonal';
  constructor(public payload: any[]) {}
}

export class SetOptionSelected {
  static readonly type = '[SeasonalPrediction] Set OptionSelected Seasonal';
  constructor(public payload: string) {}
}

export class SetDetailDataSeasonal {
  static readonly type = '[SeasonalPrediction] Set DetailData Seasonal';
  constructor(public payload: {}) {}
}

export class SetYearUncheckedOptionSelected {
  static readonly type =
    '[SeasonalPrediction] Set Year Unchecked Option Selected';
  constructor(public payload: any) {}
}

export class SetIdOptionSelect {
  static readonly type = '[SeasonalPrediction] Set IdOptionSelect Seasonal';
  constructor(public payload: string) {}
}

export class SetResetState {
  static readonly type = '[SeasonalPrediction] Set ResetState Seasonal';
  constructor() {}
}

export class SetSeasonalOption {
  static readonly type = '[SeasonalPrediction] Set Seasonal Option';
  constructor(public payload: string) {}
}

export class GetSeasonalDataDetails {
  static readonly type = '[SeasonalPrediction] Get Seasonal Data Details';
  constructor(public payload: any) {}
}

export class SetSeasonalMedidorId {
  static readonly type =
    '[SeasonalPrediction] Set Seasonal selected medidor Id';
  constructor(public medidor: number) {}
}

export class ClearOptionSelected {
  static readonly type = '[SeasonalPrediction] Clear Option Selected';
  constructor() {}
}
